import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

import pcProductReducer from './PCProduct/store/pcProductReducer';
import mobileProductReducer from './MobileProduct/store/mobileProductReducer';

import historyReducer from './ProductHistories/store/historyReducer';
import baseboardReducer from '../sc-productComponents/Baseboard/store/baseboardReducer';
import batteryReducer from '../sc-productComponents/Battery/store/batteryReducer';
import cpuReducer from '../sc-productComponents/CPU/store/cpuReducer';
// import detailsReducer from '../sc-productComponents/Details/store/detailsReducer';
import gpuReducer from '../sc-productComponents/GPU/store/gpuReducer';
import memoryReducer from '../sc-productComponents/Memory/store/memoryReducer';
import nicReducer from '../sc-productComponents/NIC/store/nicReducer';
import storageReducer from '../sc-productComponents/Storage/store/storageReducer';
import storageProductsReducer from './StorageProduct/store/storageProductReducer';
import unpairedProductReducer from './UnpairedProduct/store/unpairedProductReducer';

import reportReducer from '../sc-productComponents/Report/ErasureReport/store/reportReducer';


import PCProduct from './PCProduct';
import MobileProduct from './MobileProduct';
import StorageProduct from './StorageProduct';
import DisplayProduct from './DisplayProduct';

import ProductHistories from './ProductHistories';

import UnpairedProduct from './UnpairedProduct';
import UnpairedProductAssignToExisting from './UnpairedProduct/UnpairedProductAssignToExisting';
import { hasExternalSettingsAvailable } from '../sc-utilities';

export const routes = (basePath) => (
    <Switch>
        {<Route path={basePath + '/pc-products'} component={PCProduct} />}
        {<Route path={basePath + '/mobileProducts'} component={MobileProduct} />}
        {<Route path={basePath + '/displayProducts'} component={DisplayProduct} />}
        {<Route path={basePath + '/storageProducts'} component={StorageProduct} />}
        {hasExternalSettingsAvailable() ? <Route path={basePath + '/unpairedProducts'} component={UnpairedProduct} /> : null}
        {hasExternalSettingsAvailable() ? <Route path={basePath + '/unpairedProducts/assignToExisting'} component={UnpairedProductAssignToExisting} /> : null}
        {<Route path={'/product/histories'} component={ProductHistories} />}


    </Switch>
);
export const subComponents = (translations) => [
    { name: translations["all_assets"] || "All assets", path: '/all-assets', permissions: ['all_assets_view'] },
    { name: translations["pc_product"] || "Work", path: '/pc-products', permissions: ['product'] },
    { name: translations["mobile_product"] || "Mobile", path: '/mobile-products', permissions: ['product'] },
    // { name: 'Display product', path: '/displayProducts', permissions: [] },
    { name: translations["storage_product"] || "Single disk-drives", path: '/storage-products', permissions: ['product'] },

];

export const reducers = combineReducers({
    pcProducts: pcProductReducer,
    mobileProducts: mobileProductReducer,
    storageProducts: storageProductsReducer,
    histories: historyReducer,
    baseboards: baseboardReducer,
    batteries: batteryReducer,
    cpus: cpuReducer,
    gpus: gpuReducer,
    nics: nicReducer,
    memories: memoryReducer,
    storages: storageReducer,
    unpairedProducts: unpairedProductReducer,
    report: reportReducer,

});
